import { DefaultService } from "../DefaultService";

export default class B2BSegmentoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(...params) {
        return this._http.get(encodeURI(`${this._env}/b2bsegmento/findall.json?param=${params}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }
}